export default __webpack_public_path__ + "static/media/mode-2020.0d8e24b2.svg";